/**
 * @description Retrieves informaton about the contract that personnel are being assigned to
 */

import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

/**
 * Fetches the contract information
 * @param {[queryId: string, contractId: number]} context - react query context
 * @returns {Promise<object>} - contract information
 */
function fetchContractInfo (context) {
  // eslint-disable-next-line no-unused-vars
  const [_, contractId] = context.queryKey;

  return fetch(`/contractAssignment/contract/${ contractId }/show`)
    .then(decodeJson)
    .catch(({ body, status }) => {
      if (status === 404) {
        throw new ApiError('Unable to locate contract information. Reselect it from the contract list and choose "Assign Personnel".');
      }

      throw new ApiError(body ? `Error: ${ body }` : 'Unable to retrieve contract information. Please reload the page and try again');
    });
}

const useContractInfo = () => {
  const { contractId } = useParams();

  const value = useQuery({
    queryKey: ['useContractInfo', contractId],
    queryFn: fetchContractInfo,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });

  return value;
}

export default useContractInfo;
